export enum UserMemberAttachStatusEnum {
    ERR_RUNNER_ALREADY_ASSOCIATED = 'ERR_RUNNER_ALREADY_ASSOCIATED',
    OK_ALREADY_REQUESTED = 'OK_ALREADY_REQUESTED',
    OK_RUNNER_ASSOCIATED = 'OK_RUNNER_ASSOCIATED',
    OK_RUNNER_ASSOCIATION_REQUESTED = 'OK_RUNNER_ASSOCIATION_REQUESTED',
}
